<div class="indeterminate-progress-dialog">
  <div class="new-campaign-container loading-container">
    @if (!isDarkTheme) {
      <img mat-card-image src="/assets/img/buzz/buzz-loading-anim-lightmode.svg" alt="{{ 'generic.loading' | translate }}" class="loading-image" />
    }
    @if (isDarkTheme) {
      <img mat-card-image src="/assets/img/buzz/buzz-loading-anim-darkmode.svg" alt="{{ 'generic.loading' | translate }}" class="loading-image" />
    }
  </div>
</div>
